import { Component, Input } from '@angular/core';
import { UsersService } from '@app/services/users.service';
import { SitesService } from '@app/services/sites.service';
import { VideoAIService } from '@app/services/cloud-ai.service';
import { DealerPlanService } from '@app/services/service-plan.service';
import ims from '../../../imports'
import { Helper } from 'src/4services/2helper';
import { lastValueFrom } from 'rxjs';
import { BaseComponent } from '@app/directives/base-component';

@Component({
    selector: 'tooltip-wrapper',
    templateUrl: './tooltip-wrapper.component.html',
    styleUrls: ['../../common.scss', './tooltip-wrapper.component.scss', '../c_card_site_plan_v3.component.scss'],
    standalone: false
})
export class tooltip_wrapper_component extends BaseComponent {
  @Input() sitePlan;
  @Input() currentDealerPlan;
  @Input() moveToLeft:boolean = false;
  @Input() hasCHeKTBridge: boolean = false;

  dealerId = this.usersService.dealerId;
  site: any;
  isShown = false;
  isLoading = false;

  readonly tableHeader = [
    { name: 'Service', width: "40%" },
    { name: 'Status', width: "30%" },
    { name: 'Plan Access', width: "30%" },
  ]

  isHasViewInvoicePermission = false;
  isRegisteredDeviceSite = false;
  ttsPlanData = {
    originStatus: false,
    enable: false,
    thisMonthEnable: false,
    price: 0
  };
  remoteAccessPlanData = {
    originStatus: false,
    enable: false,
    thisMonthEnable: false,
    price: 0
  };

  // cloud AI
  isEnabledCloudAIDealerLevel = false;
  isEnabledCloudAISiteLevel = false;
  enabledCloudAICameraNumber = [];

  // service plan
  servicePricing = {
    sitePlanFee: 0,
    videoVaultPlanFee: 0,
    videoVaultPlusPlanFee: 0,
    videoVaultPlusAIPlanFee: 0,
    videoEvent: {
      free_package_amount: {
        event: 0
      },
      paid_package_amount: {
        price: 0,
        event: 0
      },
    }, 
    cloudAIEvent: {
      free_package_amount: {
        event: 0
      },
      paid_package_amount: {
        price: 0,
        event: 0
      },
    }, 
    sum: 0,
  }
  subDealerServicePricing = {
    videoVaultPlanFee: 0,
    videoVaultPlusPlanFee: 0,
    videoVaultPlusAIPlanFee: 0
  }
  videoAmountForSubDealerStandard = {
    videoEvent: {
      free_package_amount: {
        event: 0,
      },
      paid_package_amount: {
        price: 0,
        event: 0
      },
    }, 
  }
  videoAmountForSubDealerProfessional = {
    videoEvent: {
      free_package_amount: {
        event: 0,
      },
      paid_package_amount: {
        price: 0,
        event: 0
      },
    }, 
  }
  videoAmountForSubDealerPremium = {
    videoEvent: {
      free_package_amount: {
        event: 0,
      },
      paid_package_amount: {
        price: 0,
        event: 0
      },
    }, 
  }


  constructor(
    public usersService: UsersService,
    private sitesService: SitesService,
    private videoAIService: VideoAIService,
    private dealerPlanService: DealerPlanService,
    private helper: Helper,
  ) { super(); }

  async ngOnInit(){
    this.site = this.sitesService.selSite;
    await this.getSiteDeviceConfig();
    await this.setServicePricing();
    this.isHasViewInvoicePermission = this.helper.permission.has('dealer_invoice_read')
  }

  // -------------------------------------
  /////////////////////////////
  // Plan Case
  isVideoEventChargePlan(planId){
    planId = parseInt(planId)
    return planId === 9 ? true : false
  }
  isVideoAIEventsPlan(planId){
    planId = parseInt(planId)
    return planId === 13 ? true : false
  }
  isAlarmBasedSitePlan(planId){
    planId = parseInt(planId)
    return planId === 15 ? true : false
  }
  isVideoVaultPlan(planId){
    planId = parseInt(planId)
    return planId === 16 ? true : false
  }
  isVideoVaultPlusPlan(planId){
    planId = parseInt(planId)
    return planId === 17 ? true : false
  }
  isVideoVaultPlusAIPlan(planId){
    planId = parseInt(planId)
    return planId === 20 ? true : false
  }

  retryCall = 0
  async setServicePricing(){
    if(!this.dealerPlanService?.dealerPlanPricingListForStandard) {
      if(this.retryCall < 10) {
        this.retryCall++
        await ims.tool.sleep(100)
        await this.setServicePricing() // waiting and recall;
      }
    }

    const dealerPlanPricingListForStandard = this.dealerPlanService.dealerPlanPricingListForStandard
    const dealerPlanPricingListForProfessional = this.dealerPlanService.dealerPlanPricingListForProfessional
    const dealerPlanPricingListForPremium = this.dealerPlanService.dealerPlanPricingListForPremium
    const subDealerPlanPricingListForStandard = this.dealerPlanService.subDealerPlanPricingListForStandard
    const subDealerPlanPricingListForProfessional = this.dealerPlanService.subDealerPlanPricingListForProfessional
    const subDealerPlanPricingListForPremium = this.dealerPlanService.subDealerPlanPricingListForPremium 

    let target = null
    if(this.site.dealer_type === 2) {
      target = dealerPlanPricingListForPremium
    } else {
      if(this.currentDealerPlan === 1) target = dealerPlanPricingListForStandard
      if(this.currentDealerPlan === 2) target = dealerPlanPricingListForProfessional
      if(this.currentDealerPlan === 3) target = dealerPlanPricingListForPremium
    }
    this.parseServicePricing(target)
    this.parseSubDealerServicePrice('basic', subDealerPlanPricingListForStandard)
    this.parseSubDealerServicePrice('professional', subDealerPlanPricingListForProfessional)
    this.parseSubDealerServicePrice('premium', subDealerPlanPricingListForPremium)
  }

  parseServicePricing(pricingList){
    for(const planId in pricingList) {
      const plan = pricingList[planId]
      if(this.isAlarmBasedSitePlan(planId)) {
        this.assignPlanPriceByPlan('sitePlanFee', plan)
      }
      if(this.isVideoAIEventsPlan(planId)) {
        this.assignPlanPriceByPlan('cloudAIEvent', plan)
      }
      if(this.isVideoVaultPlan(planId)) {
        this.assignPlanPriceByPlan('videoVaultPlanFee', plan)
      }
      if(this.isVideoVaultPlusPlan(planId)) {
        this.assignPlanPriceByPlan('videoVaultPlusPlanFee', plan)
      }
      if(this.isVideoVaultPlusAIPlan(planId)) {
        this.assignPlanPriceByPlan('videoVaultPlusAIPlanFee', plan)
      }
      if(this.isVideoEventChargePlan(planId)) {
        this.assignPlanPriceByPlan('videoEvent', plan)
      }
    }
  }
  assignPlanPriceByPlan(planName, data){
    if(!planName || !data) return

    const targetServicePricing = this.servicePricing

    const conditionalPriceData = data?.conditional_price
    if(conditionalPriceData instanceof Object) {
      targetServicePricing[planName] = {
        free_package_amount: {
          event: this.formatNumbersWithComma(conditionalPriceData?.free_package_amount)
        },
        paid_package_amount: {
          price: this.formatNumbersWithComma(conditionalPriceData?.fee_per_paid_package_amount ),
          event: this.formatNumbersWithComma(conditionalPriceData?.paid_package_amount)
        }
      }
    } else {
      targetServicePricing[planName] = this.formatNumbersWithComma(data?.price)

      const price = data?.price ?? 0
      this.checkUnlimitedOrIncludedPlan('price', price, targetServicePricing, planName)
    }
  }

  parseSubDealerServicePrice(dealerPlan, pricingList){
    for(const planId in pricingList) {
      const plan = pricingList[planId]
      if(this.isVideoVaultPlan(planId)) {
        this.assignSubDealerPlanPriceByPlan(dealerPlan, 'videoVaultPlanFee', plan)
      }
      if(this.isVideoVaultPlusPlan(planId)) {
        this.assignSubDealerPlanPriceByPlan(dealerPlan, 'videoVaultPlusPlanFee', plan)
      }
      if(this.isVideoVaultPlusAIPlan(planId)) {
        this.assignSubDealerPlanPriceByPlan(dealerPlan, 'videoVaultPlusAIPlanFee', plan)
      }
      if(this.isVideoEventChargePlan(planId)) {
        this.assignSubDealerPlanPriceByPlan(dealerPlan, 'videoEvent', plan)
      }
    }
  }
  assignSubDealerPlanPriceByPlan(dealerPlan, planName, data){
    if(!dealerPlan || !planName || !data) return

    this.calAllServicePricing(this.subDealerServicePricing, planName, data)
    if(planName === 'videoEvent') {
      if(dealerPlan === 'basic') this.calAllServicePricing(this.videoAmountForSubDealerStandard, planName, data)
      if(dealerPlan === 'professional') this.calAllServicePricing(this.videoAmountForSubDealerProfessional, planName, data)
      if(dealerPlan === 'premium') this.calAllServicePricing(this.videoAmountForSubDealerPremium, planName, data)
    }
  }
  calAllServicePricing(targetServicePricing, planName, data){
    targetServicePricing[planName] = this.formatNumbersWithComma(data?.price)

    const conditionalPriceData = data?.conditional_price
    if(conditionalPriceData instanceof Object) {
      targetServicePricing[planName] = {
        free_package_amount: {
          event: this.formatNumbersWithComma(conditionalPriceData?.free_package_amount),
        },
        paid_package_amount: {
          price: this.formatNumbersWithComma(conditionalPriceData?.fee_per_paid_package_amount ),
          event: this.formatNumbersWithComma(conditionalPriceData?.paid_package_amount)
        }
      }
    } else {
      targetServicePricing[planName] = this.formatNumbersWithComma(data?.price)

      const price = data?.price ?? 0
      this.checkUnlimitedOrIncludedPlan('price', price, targetServicePricing, planName)
    }
  }

  // -----------------------------------------------------
  // 여기서 pricicing은 모두 호출해두어야 할 것 같다.
  async getSiteDeviceConfig() {
    try {
      const siteId = this.site.site_id;
      const {
        enabled,
        dealer_videoai_config,
        device_videoai_configs // 해당 사이트의 모든 device list
      } = await lastValueFrom(this.videoAIService.getSiteCloudAIConfig(this.dealerId(), siteId, 'device'))

      this.isEnabledCloudAIDealerLevel = this.hasCHeKTBridge && !!dealer_videoai_config?.enabled
      this.isEnabledCloudAISiteLevel = this.hasCHeKTBridge && !!enabled
      this.enabledCloudAICameraNumber = device_videoai_configs.filter(v => v?.videoai_enabled)?.length ?? 0
      this.isRegisteredDeviceSite = device_videoai_configs?.length > 0
    } catch(err) {
      this.isLoading = false;
    }
  }

  //---------------------------------
  showTTSPlanData(){
    if(this.currentDealerPlan != 1 || this.sitePlan != 1) return 'Included'
    return this.ttsPlanData.enable ? 'Enabled' : 'Disabled'
  }
  showRemoteAccessData(){
    if(this.currentDealerPlan != 1 || this.sitePlan != 1) return 'Included'
    return this.remoteAccessPlanData.enable ? 'Enabled' : 'Disabled'
  }

  showSitePlanPrice(){
    switch(this.sitePlan) {
      case(1): return 0
      case(2): return this.servicePricing.videoVaultPlanFee
      case(3): return this.servicePricing.videoVaultPlusPlanFee
      case(4): return this.servicePricing.videoVaultPlusAIPlanFee
      default: return 0
    }
  }

  // ----------------------------------
  computedSitePlanBadge(){
    switch(this.sitePlan){
      case(1) :return 'basic'
      case(2) :return 'video-vault'
      case(3) :return 'video-vault-plus'
      case(4) :return 'video-vault-plus-ai'
    }
  }
  computedSitePlanName(){
    switch(this.sitePlan){
      case(1) :return 'Basic'
      case(2) :return 'Video Vault'
      case(3) :return 'Video Vault Plus'
      case(4) :return 'Video Vault Plus AI'
    }
  }

  ///////////////////////////////////
  // TOOL
  formatNumbersWithComma(value){
    if(typeof value === 'string' && value.includes(',')) return
    if(value === undefined || value === null) value = 0
    let number = parseFloat(value)
    return number.toLocaleString('en-US')
  }
  formatNumberWithCommaToNumber(value){
    if(!value) return 0
    return parseInt(value.replace(/,/g, ""))
  }
  checkUnlimitedOrIncludedPlan(pricingType, pricingData, targetData, planName){
    if(pricingType === 'conditional') {
      const paidPackageDataIsZero = !pricingData?.fee_per_paid_package_amount && !pricingData?.paid_package_amount
      if(!paidPackageDataIsZero) return

      if(this.isUnlimitedInAllDealerPlan('conditional', planName)) {
        targetData[planName].priceLabel = 'Included'
      } else {
        targetData[planName].priceLabel = 'Unlimited'
      }
    }
    if(pricingType === 'price') {
      if(!pricingData?.price) return

      if(this.isUnlimitedInAllDealerPlan('price', planName)) {
        targetData[planName] = {
          priceLabel : 'Included',
          price : pricingData?.price
        }
      } else {
        targetData[planName] = {
          priceLabel : 'Unlimited',
          price : pricingData?.price
        }
      }
    }
  }
  isUnlimitedInAllDealerPlan(pricingType, planName){
    const standardServicePricing = this.servicePricing

    if(pricingType === 'conditional') {
      const standardPaidPackageDataIsZero = !standardServicePricing?.[planName]?.fee_per_paid_package_amount && !standardServicePricing?.[planName]?.paid_package_amount
      return standardPaidPackageDataIsZero ? true : false
    }
    if(pricingType === 'price'){
      const standardPaidPackageDataIsZero = !standardServicePricing?.[planName]?.price && !standardServicePricing?.[planName]?.price
      return standardPaidPackageDataIsZero ? true : false
    }
  }
}
